import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import VuiBox from "components/VuiBox";
import ScheduleOverview from "layouts/dashboard/components/ScheduleOverview";

function Schedules() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <ScheduleOverview />
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Schedules; 